import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { State } from '@app/app.reducer';
import { updateAnalyticsProperties } from '@app/core/analytics.actions';

import { StorageService } from './storage.service';

export interface TargetUser {
  id?: string;
  fhirIdentifier?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TargetUserService {
  private targetUser: TargetUser | null;

  private TARGET_USER_STORAGE_KEY = 'target_user_id';

  constructor(private storageService: StorageService, protected store: Store<State>) {
    this.targetUser = null;
  }

  getTargetUser(): TargetUser | null {
    const targetUserIdentifier = this.storageService.getItem(this.TARGET_USER_STORAGE_KEY);
    if (targetUserIdentifier) {
      return {
        fhirIdentifier: targetUserIdentifier,
      };
    }
    return this.targetUser;
  }

  setTargetUser(target: TargetUser) {
    this.targetUser = target;
    this.storageService.setItem(this.TARGET_USER_STORAGE_KEY, target.fhirIdentifier);
    this.store.dispatch(
      updateAnalyticsProperties({
        updates: {
          switched_account: true,
        },
      }),
    );
  }

  resetTargetUser() {
    this.targetUser = null;
    this.storageService.removeItem(this.TARGET_USER_STORAGE_KEY);
    this.store.dispatch(
      updateAnalyticsProperties({
        updates: {
          switched_account: false,
        },
      }),
    );
  }
}
